import * as React from 'react';
import { Pressable, View } from 'react-native';

import { Text } from '@/components/ui/text';
import type { OnboardingIntent } from '@/features/onboarding/types';
import { SetupLayout } from '@/features/setup/components/setup-layout';
import { useSetupContext } from '@/features/setup/setup-provider';
import { cn } from '@/lib/utils';

const STEP = 3;

const INTENT_OPTIONS: { id: OnboardingIntent; label: string; description: string }[] = [
  {
    id: 'REVIEWER',
    label: 'Rate a dish I just had',
    description: 'Share your thoughts on what you ate',
  },
  {
    id: 'WISHLIST_BUILDER',
    label: 'Save somewhere I want to try',
    description: 'Build a list of places to visit',
  },
  { id: 'TRACKER', label: "Track where I've been", description: 'Log your dining experiences' },
];

export function IntentCaptureScreen() {
  const { advance, goBack, isAdvancing, payload, setIntent } = useSetupContext();
  const selectedIntent = payload.intent;

  return (
    <SetupLayout
      step={STEP}
      onBack={goBack}
      primaryLabel="Continue"
      onPrimary={advance}
      primaryDisabled={selectedIntent === undefined}
      primaryLoading={isAdvancing}
    >
      <Text className="mb-2 text-xl font-bold text-foreground">
        What sounds most fun to start with?
      </Text>
      <Text className="mb-6 text-sm text-muted-foreground">You can do all of these later.</Text>

      <View className="gap-3">
        {INTENT_OPTIONS.map((option) => {
          const isSelected = selectedIntent === option.id;
          return (
            <Pressable
              key={option.id}
              testID={`intent-${option.id}`}
              onPress={() => setIntent(option.id)}
              accessibilityRole="radio"
              accessibilityState={{ selected: isSelected }}
              className={cn(
                'rounded-lg border p-4',
                isSelected ? 'border-primary bg-primary/10' : 'border-border'
              )}
            >
              <Text className="text-base font-semibold text-foreground">{option.label}</Text>
              <Text className="mt-1 text-sm text-muted-foreground">{option.description}</Text>
            </Pressable>
          );
        })}
      </View>
    </SetupLayout>
  );
}
